export function saveBlob(blob: Blob, fileName: string): void {
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(link.href);
}

export function getFilenameFromContentDisposition(contentDisposition: string | null): string | null {
  const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;

  if (contentDisposition && filenameRegex.test(contentDisposition)) {
    const matches = filenameRegex.exec(contentDisposition);
    if (matches?.[1]) {
      return matches[1].replace(/['"]/g, '');
    }
  }

  return null;
}
